import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {UtilsService} from "../../../../core/utils/utils.service";
import {PointDeLivraisonService} from "../../../../core/services/entities/point-de-livraison.service";
import {STATUTS_MENUS} from 'app/core/constants';
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {Subscription} from "rxjs";
import DatesDetailsFromMenuDTO from "../../../../core/dtos/planification/dates-details-from-menu-dto";
import PrestationCommandeClientDTO from "../../../../core/dtos/planification/prestation-commande-client-dto";
import RowEffectifsCommandesClientDTO from "../../../../core/dtos/planification/row-effectifs-commandes-client-dto";
import {TypeEffectifEnum} from "../../../../core/enums/type-effectif-enum";
import {CommandesClientService} from "../../../../core/services/entities/commandes-client.service";
import PlcEffectifsCommandesClientDTO from "../../../../core/dtos/planification/plc-effectifs-commandes-client-dto";

@Component({
  selector: 'yo-prestations-plc',
  templateUrl: './prestations-plc.component.html',
  styleUrls: ['./prestations-plc.component.scss']
})
export class PrestationsPlcComponent implements OnInit, OnDestroy, OnChanges {

  subTypeEffectif: Subscription;

  colWidth: 80;

  STATUTS_MENUS = STATUTS_MENUS;

  TypeEffectifEnum = TypeEffectifEnum;

  @Input("plc") pointsDeLivraison: PlcEffectifsCommandesClientDTO[];
  @Input("prestation") prestation: PrestationCommandeClientDTO;
  @Input("cols") cols: Date[]
  @Input("datesDetailsFromMenu") datesDetailsFromMenu: DatesDetailsFromMenuDTO;
  @Input("typeEffectif") typeEffectif: TypeEffectifEnum;
  @Input("datesFacturation") datesFacturation: Date[];
  @Input("selectedCell") selectedCell: RowEffectifsCommandesClientDTO;

  loadingVisible: boolean = false;

  timer: any;

  displayRegime: boolean = true;

  constructor(public utils: UtilsService,
              private auth2Svc: Auth2Service,
              private commandesClientSvc: CommandesClientService) {
  }

  ngOnInit(): void {
    this.typeEffectifSubscription();
    this.initDisplayRegime();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subTypeEffectif);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['typeEffectif'] || changes['prestations'] || changes['repas'] || changes['selectedCell']) {
      this.selectedCell = changes['selectedCell'].currentValue;
      if (this.selectedCell) {
        this.showRepas(this.selectedCell);

        const elemId = this.selectedCell?.cmcrPlcDate?.id
          ? String(this.selectedCell.cmcrPlcDate.id)
          : String(this.selectedCell?.gcomCmcrPlcDate?.id);

        if (elemId) {
          const elem = document.getElementById(elemId);
          elem?.focus();
        }
      }
    }
  }

  keyDown = event => event.target.value = event.target.value.replace(/[^0-9]/g, "");

  /**
   * Subscription qui permet de récupérer le type d'effectif sélectionné
   */
  typeEffectifSubscription = () => {
    this.subTypeEffectif = this.commandesClientSvc.selectedTypeEffectif$.subscribe(response => {
      this.typeEffectif = response;
    });
  };

  /**
   * Méthode qui permet d'afficher les détails de la cellule sélectionnée
   */
  showRepas = (cell: RowEffectifsCommandesClientDTO) => {
    this.selectedCell = cell;
    this.commandesClientSvc.announceSelectedCell(this.selectedCell);
    this.commandesClientSvc.announceSelectedPrestation(this.prestation);

    if (this.selectedCell) {
      this.commandesClientSvc
        .announceDetailsEffectifCommandeClient(this.selectedCell.details.filter(detail => detail.typeEffectif === this.typeEffectif));
    }
  };

  /**
   * Vérifie si la cellule est sélectionnée
   */
  isCellSelected = (cell: RowEffectifsCommandesClientDTO): boolean => {
    if (!this.selectedCell || !cell) {
      return false;
    }

    // Comparer par gcomCmcrPlcDate.id si disponible
    if (cell.gcomCmcrPlcDate?.id && this.selectedCell.gcomCmcrPlcDate?.id) {
      return cell.gcomCmcrPlcDate.id === this.selectedCell.gcomCmcrPlcDate.id;
    }

    // Sinon comparer par cmcrPlcDate.id
    if (cell.cmcrPlcDate?.id && this.selectedCell.cmcrPlcDate?.id) {
      return cell.cmcrPlcDate.id === this.selectedCell.cmcrPlcDate.id;
    }

    return false;
  };

  /**
   * Méthode qui permet de permettre, ou non, à un utilisateur de modifier un effectif selon la cellule
   */
  isEffectifInputDisabled = (cell: RowEffectifsCommandesClientDTO): boolean => {
    if (this.showStatutMode(cell) != STATUTS_MENUS.SAISIE_EFFECTIFS) return true;
    else if (this.utils.isDateInList(new Date(cell.date), this.datesFacturation) && cell.cmcrPlcDate.ligneFacturationId != 0) return true;
    else return !this.auth2Svc.isSiteLocal(cell.cmcrPlcDate.cmSiteId);
  };

  /**
   * Méthode qui permet de modifier l'effectif de la cellule sélectionnée
   */
  changeEffectif = ($event: number, cell: RowEffectifsCommandesClientDTO) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.selectedCell = cell;
      if (this.typeEffectif === TypeEffectifEnum.PREVISIONNEL) cell.effectifPrevisionnel = $event;
      if (this.typeEffectif === TypeEffectifEnum.FABRICATION) cell.effectifFabrication = $event;
      if (this.typeEffectif === TypeEffectifEnum.FACTURATION) cell.effectifFacturation = $event;

      this.commandesClientSvc.announceRowUpdated(cell);
    }, 25);
  };

  /**
   * Méthode qui permet d'afficher le statut du menu
   */
  showStatutMode = (row: RowEffectifsCommandesClientDTO) => {
    if (this.datesDetailsFromMenu.datesCreationMenus.find(d => d === row.date)) return STATUTS_MENUS.CREATION_MENUS;
    else if (this.datesDetailsFromMenu.datesSaisieEffectifs.find(d => d === row.date)) return STATUTS_MENUS.SAISIE_EFFECTIFS;
    else {
      if (row.cmcrPlcDate && row.cmcrPlcDate.statutMenuId == 1) return STATUTS_MENUS.CREATION_MENUS;
      else if (row.cmcrPlcDate && row.cmcrPlcDate.statutMenuId == 2) return STATUTS_MENUS.SAISIE_EFFECTIFS;
    }
  }

  /**
   * Méthode qui permet d'afficher le régime associé à la cellule sélectionnée
   */
  showRegime = (item: PlcEffectifsCommandesClientDTO) => item.rows[0].regime.libelle;

  /**
   * Méthode qui permet de récupérer l'effectif lié à la colonne, donc ici lié à la date
   */
  getEffectif = (rows: RowEffectifsCommandesClientDTO[], col: Date) => rows.find(row => new Date(row.date).getDate() === col.getDate());

  private initDisplayRegime = () => {
    this.displayRegime = !this.pointsDeLivraison.some(item => item.rows.some(row => row.regime == null));
  };

  canModifyEffectif = (cell: RowEffectifsCommandesClientDTO): boolean => cell?.gcomCmcrPlcDate ? true : cell.cmcrPlcDate?.ligneFacturationId === 0;

  hasImportEffectif = (cell: RowEffectifsCommandesClientDTO, typeEffectif: TypeEffectifEnum) => cell.details
    .filter(d => d.typeEffectif === typeEffectif)
    .reduce((sum, d) => sum + d.effectifPrevu, 0) > 0;
}
